(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_accordion-row"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('accordion-custom').forEach(function(accordion) {
      var content = accordion.querySelector('.details-content');
      if (content && content.textContent.trim() !== '') {
        accordion.classList.add('has-content');
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
